















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"])
})
export default class ChargeDetail extends Vue {
    @Prop({ type: Object })
    tableData?: Charge.ChargeRecord;

    @Prop({ type: Object })
    bookData?: Charge.Charge;

    detailData: Charge.HistoryDetails[] = [];
    totalCharge: number = 0;
    balanceCharge: number = 0;
    actualCharge: number = 0;
    paymentMethod: string = "";
    chargeDate: string = "";
    chargeNo: string = "";
    writtenPerson = "";
    bookName: string = ""; //企业名称
    mounted() {
        if (this.tableData) {
            if (this.tableData.bookName) {
                this.bookName = this.tableData.bookName;
            }
        }
        if (this.bookData) {
            this.bookName = this.bookData.bookName;
        }
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        if (this.tableData) {
            Vue.axios.post(`charge/historydetail`, this.tableData).then(res => {
                this.detailData = res.data.chargeHistoryDetails;
                this.chargeNo = res.data.chargeNo;
                this.paymentMethod = res.data.paymentMethod;
                this.chargeDate = res.data.chargeDate;
                this.totalCharge = res.data.totalCharge;
                this.balanceCharge = res.data.balanceCharge;
                this.actualCharge = res.data.actualCharge;
                this.writtenPerson = res.data.writtenPerson;
            });
        }
    }
}
